import React from 'react';
import NewLocalSettings from './LocalSettings';
import ParticipantStack from '../containers/ParticipantStack';
import { VideoDeviceInfo, AudioDeviceInfo, DeviceManager, LocalVideoStream } from '@azure/communication-calling';
import { chatScreenBottomContainerStyle } from './styles/ChatScreen.styles';

import { Stack } from '@fluentui/react';
import {
    fullHeightStyles,
    paneHeaderStyle,
    settingsContainerStyle,
    paneHeaderTextStyle
} from './styles/CommandPanel.styles';
import Footer from './Footer';
import ChatArea from '../containers/ChatArea';
import { GetSelectedCamera, GetSelectedMicrophone } from '../core/sideEffects';

let init: boolean = true;

export interface CommandPanelProps {
    selectedPane: string;
    videoDeviceInfo: VideoDeviceInfo;
    videoDeviceList: VideoDeviceInfo[];
    audioDeviceList: AudioDeviceInfo[];
    audioDeviceInfo: AudioDeviceInfo;
    setSelectedPane: any;
    setVideoDeviceInfo(device: VideoDeviceInfo): void;
    setAudioDeviceInfo(device: AudioDeviceInfo): void;
    deviceManager: DeviceManager;
    setLocalVideoStream(localVideoStream: LocalVideoStream | undefined): void;

}
export enum CommandPanelTypes {
    None = 'none',
    People = 'People',
    Settings = 'Settings',
    Chat = 'Chat',
    HelpButton ="HelpButton"
}

export default (props: CommandPanelProps): JSX.Element => {

    if (init) {
        if (props.videoDeviceList.length > 0) {
            if (props.videoDeviceList.length < GetSelectedCamera()) {
                props.setVideoDeviceInfo(props.videoDeviceList[0]);
            }
            else {
                let i: number = 0;
                props.videoDeviceList.forEach((data) => {
                    if (i === GetSelectedCamera()) {
                        props.setVideoDeviceInfo(data);
                    }
                    i++;
                });
            }
        }

        if (props.audioDeviceList.length > 0) {
            if (props.audioDeviceList.length < GetSelectedMicrophone()) {
                props.setAudioDeviceInfo(props.audioDeviceList[0]);
            }
            else {
                let i: number = 0;
                props.audioDeviceList.forEach((data) => {
                    if (i === GetSelectedMicrophone()) {
                        props.setAudioDeviceInfo(data);
                    }
                    i++;
                });
            }
        }

        init = false;
    }

    return (
        <Stack styles={fullHeightStyles}>
            <Stack.Item className={paneHeaderStyle}>
                <div className={paneHeaderTextStyle}>{props.selectedPane}</div>
            </Stack.Item>
            {props.selectedPane === CommandPanelTypes.Chat && (
                <Stack className={chatScreenBottomContainerStyle} horizontal={true}>
                    <ChatArea />

                </Stack>
            )}
            {props.selectedPane === CommandPanelTypes.People && (
                <Stack.Item styles={fullHeightStyles}>
                    <ParticipantStack />
                </Stack.Item>
            )}
            {props.selectedPane === CommandPanelTypes.People && (
                <Stack.Item>
                    <Footer />
                </Stack.Item>
            )}
            {props.selectedPane === CommandPanelTypes.Settings && (
                <Stack.Item>
                    <div className={settingsContainerStyle}>
                        <NewLocalSettings
                            videoDeviceList={props.videoDeviceList}
                            audioDeviceList={props.audioDeviceList}
                            audioDeviceInfo={props.audioDeviceInfo}
                            videoDeviceInfo={props.videoDeviceInfo}
                            setVideoDeviceInfo={props.setVideoDeviceInfo}
                            setAudioDeviceInfo={props.setAudioDeviceInfo}
                            deviceManager={props.deviceManager}
                            setLocalVideoStream={props.setLocalVideoStream}
                        />
                    </div>
                </Stack.Item>
            )}
        </Stack>
    );
};